import { atom } from "jotai";

export const accessToken = atom("" as string | null);
